import React from 'react';
import { CircleCheckIcon, XIcon } from 'lucide-react';
interface CheckListProps {
  items: string[];
  tone?: 'check' | 'cross';
  columns?: 1 | 2;
  surface?: 'light' | 'dark';
  size?: 'xs' | 'sm' | 'base';
  className?: string;
}
export function CheckList({
  items,
  tone = 'check',
  columns = 1,
  surface = 'light',
  size = 'sm',
  className = ''
}: CheckListProps) {
  const Icon = tone === 'check' ? CircleCheckIcon : XIcon;
  const iconColor = tone === 'check' ? surface === 'light' ? 'text-success' : 'text-gold' : 'text-signal';
  const textColor = surface === 'light' ? 'text-body' : 'text-white';
  const textSize = size === 'xs' ? 'text-xs sm:text-sm' : size === 'sm' ? 'text-sm' : 'text-base';
  const grid = columns === 2 ? 'grid gap-x-8 gap-y-2.5 sm:grid-cols-2' : 'space-y-2.5';
  return <ul className={`${grid} ${className}`} data-id="element-59" data-mp="2kycxsqq1rxr0">
      {items.map(item => <li key={item} className={`flex items-start gap-2.5 leading-relaxed ${textSize} ${textColor}`} data-id="element-60" data-mp="2fz0bq8702uph">
          <Icon className={`mt-0.5 h-4 w-4 shrink-0 ${iconColor}`} strokeWidth={2.25} aria-hidden="true" data-id="element-61" data-mp="1ufzuqg5c2w0n" />
          <span data-id="element-62" data-mp="1z6g8k1d2gjnj">{item}</span>
        </li>)}
    </ul>;
}